export const enum NotaryEstimationWizardNames {
	WizardName = "notary",
	Step01PropertyValue = "property",
	Step02Result = "result",
	Step03Sms = "sms",
}
